
const videos = {

    init() {
        document.addEventListener("click", function (e) {
            const trigger = e.target.closest(".js-video-home");

            if (!trigger || trigger.classList.contains("_loaded")) {
                return;
            }

            const videoId = trigger.getAttribute("data-video-id");
            const iframeWrap = trigger.querySelector("._iframe");

            if (!videoId || !iframeWrap) {
                return;
            }

            iframeWrap.innerHTML = `
		<iframe
			src="https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0&modestbranding=1&playsinline=1"
			title="Vidéo de présentation"
			allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
			allowfullscreen
		></iframe>
	`;

            trigger.classList.add("_loaded");
        });
    }
};

export default videos;
